module.exports = __webpack_public_path__ + "static/media/my_profile_english.21f73e41.jpg";